import { createEvent, EventAttributes } from 'ics';
import { getUtcDate } from '../helpers';

type UseIcsAction = {
    download: (
        dateStart: string,
        dateEnd: string,
        summary: string,
        description: string,
        reservationUUID: string,
        location: string,
        organizerName: string,
        organizerMail: string
    ) => void;
};

export const useIcs = (): UseIcsAction => {
    const download = (
        dateStart: string,
        dateEnd: string,
        summary: string,
        description: string,
        reservationUUID: string,
        location: string,
        organizerName: string,
        organizerMail: string
    ): void => {
        const startDateTime = new Date(dateStart);
        const endDateTime = new Date(dateEnd);
        const createdDateTime = getUtcDate();
        const attributes: EventAttributes = {
            startInputType: 'utc',
            start: [
                startDateTime.getUTCFullYear(),
                startDateTime.getUTCMonth() + 1,
                startDateTime.getUTCDate(),
                startDateTime.getUTCHours(),
                startDateTime.getUTCMinutes(),
            ],
            end: [
                endDateTime.getUTCFullYear(),
                endDateTime.getUTCMonth() + 1,
                endDateTime.getUTCDate(),
                endDateTime.getUTCHours(),
                endDateTime.getUTCMinutes(),
            ],
            created: [
                createdDateTime.getUTCFullYear(),
                createdDateTime.getUTCMonth() + 1,
                createdDateTime.getUTCDate(),
                createdDateTime.getUTCHours(),
                createdDateTime.getUTCMinutes(),
            ],
            uid: reservationUUID,
            productId: 'e-Boks/Visningsklient',
            title: summary,
            description: description,
            location: location,
        };
        if (organizerMail) {
            attributes.organizer = { name: organizerName || '', email: organizerMail || '' };
        }
        createEvent(attributes, (error, value) => {
            if (error) {
                return;
            }
            const data = new Blob([value], { type: 'text/calendar; charset=utf-8' });
            const save = document.createElement('a');
            save.href = window.URL.createObjectURL(data);
            save.download = 'calendarapp.ics' || 'unknown';
            document.body.appendChild(save);
            save.click();
            URL.revokeObjectURL(save.href);
            save.remove();
        });
    };

    return { download };
};
